import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { debounceTime, filter, Subject, Subscription, switchMap, tap } from 'rxjs';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { LoadingService } from '../../services/loading.service';
import { NgbModal, NgbModule, NgbCarouselModule, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { MatRadioModule } from '@angular/material/radio';
import { Select2, Select2Data } from 'ng-select2-component';
import { HttpServiceService } from '../../services/http-service.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { USER_PERMISSIONS, APP_CONSTANTS } from '../../app.constants';
import { LocalStorageService } from '../../services/local-storage.service';
import { DefaultImageDirective } from '../../directives/default-image.directive';
import { UserInfo } from '../../models/users.model';
import { Offcanvas } from 'bootstrap';

@Component({
  selector: 'app-property-edit',
  imports: [BreadcrumbComponent, RouterModule, MatTabsModule, NgFor,ReactiveFormsModule, NgIf, NgClass, NgbModule, MatRadioModule, Select2, NgSelectModule, NgbCarouselModule, DefaultImageDirective, NgbAccordionModule],
  templateUrl: './property-edit.component.html',
  styleUrl: './property-edit.component.css'
})
export class PropertyEditComponent implements OnDestroy {
  breadcrumbList = {
    breadcrumb_path: 'Properties',
    currentURL: 'Property Edit',
    breadcrumb_url : '/admin/properties/properties-list'
  }
  propertyId: string = '';
  private routeSubscription? : Subscription;
  propertyForm! : FormGroup;
  propertyDetailsForm! : FormGroup;
  propertyAminitiesForm! : FormGroup;
  imagesForm! : FormGroup;
  roomsForm!: FormGroup;
  editRoomItemsForm!: FormGroup;
  uploadImagesForm! : FormGroup;
  loadingService = inject(LoadingService);  
  theme : any = [{ hedingClass: 'accordion-primary' }];
  themeClass: any = '';
  maneClass: string = '';
  positionClass: string = '';
  iconClass: string = '';
  bg: string = '';
  staticRooms : number[] = [];
  private modalService= inject(NgbModal);
  countries : Select2Data = [];
  states : Select2Data = [];
  cities : Select2Data = [];
  private getCountriesSubscription? : Subscription;
  private getStatesSubscription?: Subscription;
  private getCitiesSubscription?: Subscription;
  private updatePropertySubscription? : Subscription;
  private getPropertyDetailsSubscription? : Subscription;
  private updatePropertyDetailsSubscription? : Subscription;
  private updatePropertyAmintiesSubscription? : Subscription;
  private getAllPropertyManagersSubscription? : Subscription;
  private getAllOwnersSubscription? : Subscription;
  private uploadImagesSubscription? : Subscription;
  private getImageSubscription?: Subscription;
  private deleteImageSubscription?: Subscription;
  private getAllPropertyImagesSubscription? : Subscription;
  private savedAllowedListSubscription? : Subscription;
  private getAllRoomItemsSubscription? : Subscription;
  private saveRoomItemsSubscription? : Subscription;
  private getPropertyRoomItemsSubscription? : Subscription;
  private getAllPropertyRoomsSubscription? : Subscription;
  private updatePropertyRoomItemDetailsSubscription? : Subscription;
  private deletePropertyRoomSubscription?: Subscription;
  private updatePlatformSubscription?: Subscription;
  private authService = inject(LocalStorageService);
  private userInfo : UserInfo;
  @ViewChild('add_room_popup') offcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  propertyAminitiesList : any = [];
  allPropertyManagers : any = [];
  active : number = 1;
  allOwners : any = [];
  propertyImages : any = [{    
    image : ""
  },
  {
    image : ""
  }];
  selectedFiles : any = [];
  selectedImage : any;
  allowListingValues : any = [];
  deleteListImages : any = [];
  searchInput$ = new Subject<string>();
  offset_limit : number = 20;
  hasMore : boolean = true;
  lastSearchTerm :any;
  page: any = 1;
  totalRows: number = 10;
  totalPage: any = 0;
  add_room : boolean  = false;
  filteredRoomsList : any = [];
  filteredItems : any = [];
  activeAccordionIds = ['room-0'];
  propertyRoomsList : any = [];
  isRoomEdit : boolean = false;
  platformForm!: FormGroup;
  queryParamsData: any;
  queryParamsSubsscription?: Subscription;
  isFileChanged : boolean = false;

  constructor(private route: ActivatedRoute, private fb: FormBuilder, private alertService: NgxToastrService, private httpService : HttpServiceService, private router : Router){
   this.routeSubscription =  this.route.paramMap.subscribe(params => {
      this.propertyId = params.get('id') ?? "";
    });   
    
    this.userInfo = this.authService.getItem("userInfo") as UserInfo;
  }

  selectedProperty! : any;
  
  // activeAccordionIds: string[] = []; // all collapsed

toggleRoom(id: string): void {
    const i = this.activeAccordionIds.indexOf(id);
    if (i > -1) {
      this.activeAccordionIds.splice(i, 1);
    } else {
      this.activeAccordionIds.push(id);
    }
  }

  test(){
    let aa = document.getElementById("room-0");
    console.log(aa);
    if(aa) {
      aa.style.display = "block";
    }
  }


  /** Checkbox keys/labels for the Property Category group (order = display order). */
  readonly propertyCategoryOptions: { key: string; label: string }[] = [
    { key: 'property_category_sale', label: 'Sale' },
    { key: 'property_category_rent', label: 'End-to-End Management' },
    { key: 'property_category_property_management', label: 'Property Management' },
    { key: 'property_category_tenant_placement', label: 'Tenant Placement' },
    { key: 'property_category_plot_monitoring', label: 'Plot Monitoring' },
    { key: 'property_category_repairs_renovation', label: 'Repairs & Renovation' },
    { key: 'property_category_documentation', label: 'Documentation' },
  ];

  /**
   * property_category is a JSON object of checkbox flags. Older rows store the
   * flags as the strings "true"/"false" (multipart form), and a "false" string
   * would render as a ticked checkbox, so normalise to a real boolean.
   */
  private isCategoryTicked(property: any, key: string): boolean {
    let category = property?.property_category;
    if (typeof category === 'string') {
      try { category = JSON.parse(category); } catch { category = null; }
    }
    const value = category?.[key];
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  async intializePropertyForm(selectedProperty : any){
    this.propertyForm = this.fb.group({
      name: [selectedProperty.name, [Validators.required]],
      type: [selectedProperty.type, [Validators.required]],
      address_1: [selectedProperty.address_1, [Validators.required]],
      address_2 : [selectedProperty.address_2],
      country : ['', [Validators.required]],
      state : [selectedProperty.state, [Validators.required]],
      city : [selectedProperty.city, [Validators.required]],
      locality : [selectedProperty.locality, [Validators.required]],
      postal_code : [selectedProperty.postal_code, [Validators.required]],
      listing_status : [selectedProperty.listing_status, [Validators.required]],
      // brokerage_value : [selectedProperty.brokerage_value],
      security_deposit : [selectedProperty.security_deposit],
      // security_deposot_value : [selectedProperty.security_deposot_value],
      monthly_maintenance : [selectedProperty.monthly_maintenance],
      owner_agreement_start : [selectedProperty.owner_agreement_start],
      owner_agreement_end : [selectedProperty.owner_agreement_end],
      take_over_date : [selectedProperty.take_over_date],
      monthly_rent : [selectedProperty.monthly_rent],
      // monthly_rent_value : [selectedProperty.monthly_rent_value],
      notes : [selectedProperty.notes],
      inspection_required:[selectedProperty.inspection_required ?? '', [Validators.required]],
      contact_person : [selectedProperty.contact_person],
      contact_person_phone : [selectedProperty.contact_person_phone?.toString() ?? ""],
      status : [selectedProperty.status ?? 'Pending', [Validators.required]],
      cover_image : [selectedProperty.cover_image],
      property_managers : [selectedProperty.property_managers],
      owner_id : [selectedProperty.owner_id],
      video_url : [selectedProperty.video_url],
      property_visible : [selectedProperty.property_visible ?? ''],
      property_category_sale : [this.isCategoryTicked(selectedProperty, 'property_category_sale')],
      property_category_rent : [this.isCategoryTicked(selectedProperty, 'property_category_rent')],
      property_category_property_management : [this.isCategoryTicked(selectedProperty, 'property_category_property_management')],
      property_category_tenant_placement : [this.isCategoryTicked(selectedProperty, 'property_category_tenant_placement')],
      property_category_plot_monitoring : [this.isCategoryTicked(selectedProperty, 'property_category_plot_monitoring')],
      property_category_repairs_renovation : [this.isCategoryTicked(selectedProperty, 'property_category_repairs_renovation')],
      property_category_documentation : [this.isCategoryTicked(selectedProperty, 'property_category_documentation')],
    });

    this.propertyDetailsForm = this.fb.group({
      // project_name : [selectedProperty.name, [Validators.required]],
      description : [selectedProperty.description],
      floor : [selectedProperty.floor],
      built_up_area : [selectedProperty.built_up_area ],
      carpet_area : [selectedProperty.carpet_area],
      flooring_type :[selectedProperty.flooring_type ?? ""],
      near_by_info : [selectedProperty.near_by_info],
      facing : [selectedProperty.facing],
      number_of_parkings : [selectedProperty.number_of_parkings],
      parking_number : [selectedProperty.parking_number],
      parking_type : [selectedProperty.parking_type ?? ""],
      willing_to_rent_to_family : [selectedProperty.allowed_rental_type?.willing_to_rent_to_family],
      willing_to_rent_to_single_men : [selectedProperty.allowed_rental_type?.willing_to_rent_to_single_men],
      willing_to_rent_to_single_women : [selectedProperty.allowed_rental_type?.willing_to_rent_to_single_women],
      age : [selectedProperty.age],
      // platforms: this.fb.array([]),
      year_built :[selectedProperty.year_built],
      keys_quantity:[selectedProperty.keys_quantity],
      electrical_service_number : [selectedProperty.electrical_service_number],
      furnished_type : [selectedProperty.furnished_type ?? ""],
      total_bedrooms : [selectedProperty.total_bedrooms],
      total_bathrooms : [selectedProperty.total_bathrooms],
      total_balconies : [selectedProperty.total_balconies],
      latitude : [selectedProperty.latitude],
      longitude : [selectedProperty.longitude],
      maps_link : [selectedProperty.maps_link]
    });    

    this.propertyAminitiesForm = this.fb.group({
      propertyAminities : this.fb.array(this.propertyAminitiesList.map(() => this.fb.control(false)))
    });    

    this.uploadImagesForm = this.fb.group({      
      property_images : [null, [Validators.required]]
    }); 
    
    this.roomItemsForm();
    this.createPlatformForm();
  } 
  
  roomItemsForm(){
    this.editRoomItemsForm = this.fb.group({
      editrooms: this.fb.array([])
    });
  }

  createPlatformForm() {  
    this.platformForm = new FormGroup({
      platforms: new FormArray([])
    });
  }

  ngOnInit() {
    if (this.theme && this.theme.length > 0) { 
    this.themeClass = this.theme[0];
    this.maneClass = this.theme[0].hedingClass;
    this.positionClass = this.theme[0].postion;
    this.iconClass = this.theme[0].icon;
    this.bg = this.theme[0].bg;
    }
    let id = this.route.snapshot.paramMap.get('id')!;
    this.propertyAminitiesList = this.route.snapshot.data['data']?.["data"] ?? [];
    this.getPropertyDetailsById(id);
    this.getAllRoomItems(id);
    this.getAllUsers();
    this.getAllPropertyImages();
    // if (this.selectedProperty?.platforms) {
    //   this.selectedProperty?.platforms?.forEach((platform : any) => {
    //     this.platforms?.push(this.fb.group({
    //       name: [platform.name],
    //       platform_id: [platform.platform_id],
    //       platform_link: [platform.platform_link]
    //     }));
    //   });      
    // }
    if(this.selectedProperty?.rooms){
      for(let room in this.selectedProperty?.rooms){
        this.rooms?.push(this.fb.group({
          [room] : [this.selectedProperty?.rooms[room]]
        }))
      }  
    }
    
    this.searchInput$
      .pipe(
        debounceTime(300),
        filter(term => {
          const skip = term === this.lastSearchTerm;
          return !skip;
        }),
        tap((term) => {
          this.page = 1;
          this.hasMore = true;
          this.lastSearchTerm = term;
        }),
        switchMap(term => {
          let query = `&search=${term}&role_identifier=owner`;
          return this.httpService.getAllUsers(this.page, this.offset_limit, query);
        }
        )
      )
      .subscribe(results => {
        this.allOwners = results.data["users"] ?? [];
        if (this.allOwners.length >= results.data["total"]) {
          this.hasMore = false;
        }
        this.allOwners = results.data.users?.map((user: { first_name: string; last_name: string; }) => ({
          ...user,
          fullName: `${user.first_name} ${user.last_name}`
        }));
      });      
      this.getAllPropertyRooms();
    this.queryParamsSubsscription = this.route.queryParams.subscribe((data: any) => {
      this.queryParamsData = data;
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const offcanvasElement = this.offcanvas?.nativeElement;
      if (offcanvasElement) {
        this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
          backdrop: 'static',
          keyboard: false,
        });
      }
    });
  }  

  initRooms() {
    this.propertyRoomsList.forEach((room: {id : string, room_name: any; items: any[]; }) => {
      const roomGroup = this.fb.group({
        id : [room.id],
        room_name: [room.room_name],
        items: this.fb.array(
          room.items.map(item =>
            this.fb.group({
              id: [item.id],
              item_name: [item.item_name],
              value: [item.item_quantity]
            })
          )
        )
      });
      this.editrooms.push(roomGroup);
    });
  }

  initPlatForms() {
    this.selectedProperty.platforms?.forEach((platform: { platform_name: any; platform_id: any; property_platform_link: any; id : string, property_platform_id: string }) => {
      const platformGroup = this.fb.group({
        platform_name: [platform.platform_name],
        platform_id: [platform.platform_id],
        property_platform_link: [platform.property_platform_link],
        id: [platform.id],
        property_platform_id : [platform.property_platform_id]
      });
      this.platformsArray.push(platformGroup);
    });
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.keyCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  createRoomForm(){
    this.roomsForm = this.fb.group({
      uid : this.fb.control(''),
      searchText : this.fb.control(''),
      room_name : this.fb.control('', Validators.required),
      selectedItems: this.fb.array(this.filteredItems.map(() => this.fb.control(false)),
      this.minOneCheckboxChecked())  // FormArray for checkboxes
    });
  }

  minOneCheckboxChecked(): ValidatorFn {
    return (control: AbstractControl) => {
      const formArray = control as FormArray;
      return formArray.controls.some(ctrl => ctrl.value) ? null : { required: true };
    };
  }

  filterItems() {
    const control = this.roomsForm?.get("searchText");   
    if (!control?.value) {
      this.filteredItems = this.filteredRoomsList;
    } else {
      this.filteredItems = this.filteredRoomsList.filter((item: { name: string; }) =>
        item.name.toLowerCase().includes(control?.value?.toLowerCase())
      );
    }
  }

  getAllRoomItems(propertyId : string){
    this.getAllRoomItemsSubscription = this.httpService.getAllPropertyItems(propertyId).subscribe({
      next : (response) => {
        this.filteredItems =  response.data;        
        this.filteredRoomsList = [...response.data];
        this.createRoomForm();
      }
    })
  }

  getAllPropertyRooms(){
    this.getAllPropertyRoomsSubscription = this.httpService.getAllPropertyRooms(this.propertyId).subscribe({
      next : (response) => {
        this.propertyRoomsList = response.data;
        this.initRooms();
      }
    })
  }

  showHideEditRoom(roomId : string, room_name : string){
    this.isRoomEdit = true;
    this.getRoomDetailsBypropertyId(roomId, room_name);    
  }

  

  getRoomDetailsBypropertyId(roomId : string, room_name : string){
    this.getPropertyRoomItemsSubscription = this.httpService.getPropertyRoomItems(this.propertyId, roomId).subscribe({
      next : (response) => {
        this.roomsForm.patchValue({room_name : room_name, uid : roomId});      
        this.setRoomCheckboxes(response.data ?? []);
        this.showHideRoom();
      }
    })
  }

  setRoomCheckboxes(roomItems : any) {
      this.allFormControls?.controls.forEach((control, index) => {      
        let isChecked = roomItems.find((role:any) => role == this.filteredRoomsList[index]?.id) ? true : false;
        if(isChecked) {
          control.setValue(true);
        }else{
          control.setValue(false);
        }
      });
  } 

  getAllUsers(){
    let query = `&role_identifier=${APP_CONSTANTS.USER_ROLES.PROPERTY_MANAGER}`;
    this.getAllPropertyManagersSubscription = this.httpService.getAllUsers(1, 100, query).subscribe({
      next : (response) => {        
        this.allPropertyManagers = response.data.users?.map((user: { first_name: string; last_name: string; }) => ({
          ...user,
          fullName: `${user.first_name} ${user.last_name}`
        }));
      },
      error : (error) => {
        console.log(error);
      }
    })

    let ownerQuery = `&role_identifier=${APP_CONSTANTS.USER_ROLES.OWNER}`;
    this.getAllOwnersSubscription = this.httpService.getAllUsers(this.page, this.offset_limit, ownerQuery).subscribe({
      next : (response) => {    
        if(this.selectedProperty?.owner_id){
          let userFound = response.data.users?.find((user : any) => user.uid == this.selectedProperty.owner_id); 
          if(!userFound && response.data.users?.length) response.data.users.push(this.selectedProperty.owner);
        } 
        this.allOwners = response.data.users?.map((user: { first_name: string; last_name: string; }) => ({
          ...user,
          fullName: `${user.first_name} ${user.last_name}`
        }));
      },
      error : (error) => {
        console.log(error);
      }
    })
  }

   onScrollToEnd() {
    // Optional: For pagination / infinite scroll
    if (!this.hasMore) return;
    this.page+=1;
    this.offset_limit+=20;
    let inputValue = this.propertyForm.get("owner_id")?.value;
    console.log(inputValue);
    let query = "&role_identifier=tenant";
    this.getAllOwnersSubscription = this.httpService.getAllUsers(this.page, this.offset_limit, query).subscribe(response => {
      let resp = response.data["users"] ?? [];
      if(this.selectedProperty?.owner_id && resp.length){    
        resp = resp.filter((user : any) => user.uid != this.selectedProperty.owner_id);
      }
      if(this.allOwners.length >= response.data["total"]){
          this.hasMore = false;
      }
      resp = resp?.map((user: { first_name: string; last_name: string; }) => ({
          ...user,
          fullName: `${user.first_name} ${user.last_name}`
      }));
      this.allOwners = [...this.allOwners, ...resp];      
    });
  }

  async getPropertyDetailsById(uid : string){
    this.getPropertyDetailsSubscription = this.httpService.getPropertyDetailsById(uid).subscribe({
      next : async (response) => {
        this.selectedProperty = response.data;
        await this.intializePropertyForm(this.selectedProperty);
        this.getCountries();
        this.setCheckboxes(this.selectedProperty.amenities ?? []);
        this.initPlatForms();
      }
    })
  }

  setCheckboxes(dbAminities : any = []) {    
      this.propertyAminities?.controls?.forEach((control, index) => {      
        let isChecked = dbAminities?.find((aminity : any) => aminity == this.propertyAminitiesList[index]?.propertyAmenitiesType) ? true : false;
        if(isChecked) {
          control.setValue(true);
        }else{
          control.setValue(false);
        }
      });
  }

  addPlatform() {
    // this.platforms?.push(this.fb.group({name:'', platform_id : '', platform_link : ''}));
  }

  deletePlatforms(index :number) {
    // this.platforms.removeAt(index);
  }

  addRoom(){
    let keyName = this.roomsForm?.get("newRoom")?.value;
    if(!keyName){
      this.alertService.error("Please provide extra room details", "toast-top-right");
      return;
    }
    this.rooms.push(this.fb.group({ [keyName] : ""}));
    this.roomsForm?.get("newRoom")?.setValue('');
  }

  
  savePropertyEvent(value : boolean){
    console.log(value);
  }


  getObjectKeys(obj : any){
    return Object.keys(obj);
  }

  updateCoverPhoto(event: Event){
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files[0]) {
      const file = inputElement.files[0]; // Get the selected file
      const reader = new FileReader();  
      reader.onload = () => {
        this.selectedProperty.cover_image = reader.result as string; // Convert file to data URL
      };  
      reader.readAsDataURL(file); // Read file as Data URL
      this.propertyForm.patchValue({ cover_image: file });
      this.propertyForm.get('cover_image')?.updateValueAndValidity(); 
      this.isFileChanged = true;   
    }
  }

  saveProperty(){
    if(!this.propertyForm.valid) return;
    let basicPropertyDetails = this.propertyForm.value;    
    let country = this.countries.find((a) => a.data.id == basicPropertyDetails.country);
    if(country?.label) basicPropertyDetails.country = country.label;
    let state = this.states.find((a) => a.data.id == basicPropertyDetails.state);
    if(state?.label) basicPropertyDetails.state = state.label;
    let city = this.cities.find((a) => a.data.id == basicPropertyDetails.city);
    if(city?.label) basicPropertyDetails.city = city.label;
    basicPropertyDetails.property_category = {};
    if(basicPropertyDetails.property_category_sale) {
      basicPropertyDetails.property_category["property_category_sale"] = basicPropertyDetails.property_category_sale;
    }
    if(basicPropertyDetails.property_category_rent) {
      basicPropertyDetails.property_category["property_category_rent"] = basicPropertyDetails.property_category_rent;
    }
    if(basicPropertyDetails.property_category_property_management) {
      basicPropertyDetails.property_category["property_category_property_management"] = basicPropertyDetails.property_category_property_management;
    }
    if(basicPropertyDetails.property_category_tenant_placement) {
      basicPropertyDetails.property_category["property_category_tenant_placement"] = basicPropertyDetails.property_category_tenant_placement;
    }
    if(basicPropertyDetails.property_category_plot_monitoring) {
      basicPropertyDetails.property_category["property_category_plot_monitoring"] = basicPropertyDetails.property_category_plot_monitoring;
    }
    if(basicPropertyDetails.property_category_repairs_renovation) {
      basicPropertyDetails.property_category["property_category_repairs_renovation"] = basicPropertyDetails.property_category_repairs_renovation;
    }
    if(basicPropertyDetails.property_category_documentation) {
      basicPropertyDetails.property_category["property_category_documentation"] = basicPropertyDetails.property_category_documentation;
    }
    delete basicPropertyDetails?.property_category_sale;
    delete basicPropertyDetails?.property_category_rent;
    delete basicPropertyDetails?.property_category_property_management;
    delete basicPropertyDetails?.property_category_tenant_placement;
    delete basicPropertyDetails?.property_category_plot_monitoring;
    delete basicPropertyDetails?.property_category_repairs_renovation;
    delete basicPropertyDetails?.property_category_documentation;
    const propertyUpdateObj = Object.fromEntries(
      Object.entries(basicPropertyDetails).filter(([_, v]) => v !== null && v !== '')
    ) as unknown as any;
    if(!propertyUpdateObj?.cover_image?.["name"] || !this.isFileChanged) {
      delete propertyUpdateObj?.cover_image;
    }
    const formData = new FormData();
    Object.keys(propertyUpdateObj).forEach((key) => {
      let value = propertyUpdateObj[key];
      if (Array.isArray(value)) {
        value.forEach(item => {
          formData.append(`${key}[]`, item);
        });
      } else if (typeof value === 'object' && value !== null && !(value instanceof File)) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });    
    this.updatePropertySubscription = this.httpService.updateProperty(this.propertyId, formData).subscribe({
        next : (resp) => {          
          this.alertService.success(resp.message, "toast-top-right");
          this.isFileChanged = false;
        }
    })
  }

  savePropertyDetails(){
    if(!this.propertyDetailsForm.valid) return;
    let propertyDetails = this.propertyDetailsForm.value;
    propertyDetails.allowed_rental_type = {};
    if(propertyDetails.willing_to_rent_to_family) {
      propertyDetails.allowed_rental_type["willing_to_rent_to_family"] = propertyDetails.willing_to_rent_to_family;

    }
    if(propertyDetails.willing_to_rent_to_single_men) {
      propertyDetails.allowed_rental_type["willing_to_rent_to_single_men"] = propertyDetails.willing_to_rent_to_single_men;

    }
    if(propertyDetails.willing_to_rent_to_single_women) {
      propertyDetails.allowed_rental_type["willing_to_rent_to_single_women"] = propertyDetails.willing_to_rent_to_single_women;

    }  
    
    delete propertyDetails?.willing_to_rent_to_single_women;
    delete propertyDetails?.willing_to_rent_to_single_men;
    delete propertyDetails?.willing_to_rent_to_family; 
       
    const propertyUpdateObj = Object.fromEntries(
      Object.entries(propertyDetails).filter(([_, v]) => v !== null && v !== '')
    ) as unknown as any;
    if(propertyUpdateObj["age"]) propertyUpdateObj["age"] = propertyUpdateObj["age"].toString();
    this.updatePropertyDetailsSubscription  = this.httpService.updateProperty(this.propertyId, propertyUpdateObj).subscribe({
        next : (resp) => {          
          this.alertService.success(resp.message, "toast-top-right");
        }
    });
  }

  showHideRoom(){
    this.add_room = !this.add_room;
    if(this.offcanvasInstance) {
      if (this.add_room) {
        this.offcanvasInstance.show();
      } else {
        this.offcanvasInstance.hide();
      }
    }
  }

  addRoomClose(){
    this.showHideRoom();
    this.roomsForm.reset();
    this.isRoomEdit = false;
  }

  saveRoom(){    
    if(!this.roomsForm.valid) return;
    let roomObj = this.roomsForm.value ?? {};    
    let obj = {
      room_name : roomObj["room_name"],
      items : this.getSelectedRoomItems()
    }
    if(this.isRoomEdit){
      this.saveRoomItemsSubscription = this.httpService.updatePropertyRoom(this.propertyId, roomObj.uid, obj).subscribe({
        next : (response) => {
          this.roomItemsForm();
          this.getAllPropertyRooms();
          this.addRoomClose();
          this.alertService.success(response.message, "toast-top-right");
        }
      });
    }else{
      this.saveRoomItemsSubscription = this.httpService.savePropertyRooms(this.propertyId, obj).subscribe({
        next : (response) => {
          this.roomsForm.reset();
          this.roomItemsForm();
          this.getAllPropertyRooms();
          this.addRoomClose();
          this.alertService.success(response.message, "toast-top-right");
        }
      });
    }
  }

  savePlatforms(){
    console.log(this.platformForm.value);
    this.updatePlatformSubscription = this.httpService.updatePropertyPlatforms(this.propertyId, this.platformForm.value).subscribe({
      next : (response) =>{
        this.platformsArray?.clear();
        this.selectedProperty.platforms = response.data;
        this.initPlatForms();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  onInputBlur(roomId : string, itemId : string, value : string){
    if(roomId && itemId && parseInt(value)){
      this.updatePropertyRoomItemDetailsSubscription  = this.httpService.updatePropertyRoomItems(this.propertyId, roomId, itemId, { item_quantity : value}).subscribe({
        next : (response) => {
          this.alertService.success(response.message, "toast-top-right");
        }
      })
    }
  }

  deletePropertyRoom(roomId : string){
    this.deletePropertyRoomSubscription = this.httpService.deletePropertyRoom(this.propertyId, roomId).subscribe({
      next : (response) => {
        this.roomItemsForm();
        this.getAllPropertyRooms();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  getSelectedRoomItems() {
    const selectedItems: string[] = [];
    this.allFormControls?.controls.forEach((control, index) => {
      if (control.value) {   
        selectedItems.push(this.filteredRoomsList[index].id);
      }
    });
    return selectedItems;
  }

  getItems(roomIndex: number): FormArray {
    return this.editrooms.at(roomIndex).get('items') as FormArray;
  }

  saveRoomItems(){
    console.log(this.editRoomItemsForm.value)
  }

  saveAminities(){
    let amenities = this.getSelectedAminities;
    if(!amenities.length) {
      this.alertService.error('Please select atleast one aminity', "toast-top-right");
      return;
    }
    let obj  = { amenities };
    this.updatePropertyAmintiesSubscription = this.httpService.updateProperty(this.propertyId, obj).subscribe({
        next : (resp) => {          
          this.alertService.success(resp.message, "toast-top-right");
        }
    });
  }

  

  openCenter(content: TemplateRef<any>) {
    this.modalService.open(content, { centered: true,  backdrop: 'static' });
  }
  
  closeModal() {
    this.uploadImagesForm.reset();
    this.modalService.dismissAll();
  }

  getCountries(){    
    this.getCountriesSubscription = this.httpService.getLocations('country').subscribe({
      next : (resp) => { 
        let country = resp.data?.find((c: { name: any; }) => c.name == this.selectedProperty.country);
        for(let country of resp.data){
          this.countries.push(
            {
              value: country.id,
              label: country.name,
              data: { name: country.name, id : country.id }
            }
          )
      }      
      this.propertyForm?.patchValue({
        country: country?.id
      }); 
      this.getStates();
      },
      error : (error) => {

      }
    });
  }

  getStates(){
    let countryId = this.propertyForm?.get('country')?.value;
    if(countryId){
      this.states = [];
      this.getStatesSubscription = this.httpService.getLocations('state','&countryId='+countryId).subscribe({
        next : (resp) => { 
          let state = resp.data?.find((c: { name: any; }) => c.name == this.selectedProperty.state);
          for(let state of resp.data){
            this.states.push(
              {
                value: state.id,
                label: state.name,
                data: { name: state.name , id : state.id }
              }
            )
        }
        this.propertyForm.patchValue({
          state: state.id
        });
        this.getCities(); 
        },
        error : (error) => {
  
        }
      });
    }
  }

  getCities(){
    let stateId = this.propertyForm?.get('state')?.value;
    if(stateId){
      this.cities = [];
      this.getCitiesSubscription = this.httpService.getLocations('city','&stateId='+stateId).subscribe({
        next : (resp) => { 
          let city = resp.data?.find((c: { name: any; }) => c.name == this.selectedProperty.city);       
          for(let city of resp.data){
            this.cities.push(
              {
                value: city.id,
                label: city.name,
                data: { name: city.name , id : city.id }
              }
            )
        }
        this.propertyForm.patchValue({
          city: city.id
        }); 
        },
        error : (error) => {
  
        }
      });
    } 
  }

  viewPropertyEvent(data : any){    
    this.router.navigate(['admin', 'properties', 'property-view', this.propertyId, 1], {
      queryParams : this.queryParamsData
    });
  }

  uploadImages(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      this.selectedFiles = Array.from(inputElement.files);
      this.uploadImagesForm.patchValue({ property_images: this.selectedFiles });
      this.uploadImagesForm.get('property_images')?.updateValueAndValidity();
    }
  }

  saveImages(){
    const formData = new FormData();
    this.selectedFiles.forEach((file: string | Blob, index: any) => {
      formData.append('property_images', file);
    });    
    this.uploadImagesSubscription = this.httpService.uploadPropertyImages(formData, this.propertyId).subscribe({
      next : (response) => {
        this.getAllPropertyImages();
        this.closeModal();
        this.selectedFiles = [];
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }
  

  viewPropertyImage(content: TemplateRef<any>){
    this.modalService.open(content, { centered: true,  backdrop: 'static' });
  }
  

  deletePropertyImage(uid : string){
    this.deleteImageSubscription = this.httpService.deletePropertyImage(uid, this.propertyId).subscribe({
      next : (response) => {
        this.getAllPropertyImages();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  getAllPropertyImages(){
    this.getAllPropertyImagesSubscription = this.httpService.getAllPropertyImages(this.propertyId).subscribe({
      next : (response) => {
        this.propertyImages = response.data;        
      }
    })
  }

  saveAllowedList(uid : string, listing : boolean){
    let data = {
      uids : [uid],
      allow_listing : listing
    }
    this.savedAllowedListSubscription = this.httpService.listingImageStatus(data, this.propertyId).subscribe({
      next : (response) =>{        
        this.getAllPropertyImages();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  allowListing(uid : string, event : Event){
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    let index = this.allowListingValues.indexOf(uid);
    if(index == -1 && isChecked){
      this.allowListingValues.push(uid);
    }else{
      this.allowListingValues = this.allowListingValues.filter((id : string) => id != uid);
    }    
  }

  deleteImages(uid : string, event : Event){
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;
    let index = this.allowListingValues.indexOf(uid);
    if(index == -1 && isChecked){
      this.deleteListImages.push(uid);
    }else{
      this.deleteListImages = this.deleteListImages.filter((id : string) => id != uid);
    }
  }

  get getSelectedAminities() {
    const selectedItems: string[] = [];
    this.propertyAminities.controls.forEach((control, index) => {
      if (control.value) {       
        selectedItems.push(this.propertyAminitiesList[index].propertyAmenitiesType);
      }
    });
    return selectedItems;
  }


  get platforms() {
    return this.propertyDetailsForm?.get('platforms') as FormArray;
  }

  get rooms() {
    return this.roomsForm?.get("rooms") as FormArray;
  }

  get propertyAminities(){
    return this.propertyAminitiesForm?.get('propertyAminities') as FormArray;
  }

  get editrooms(): FormArray {
    return this.editRoomItemsForm.get('editrooms') as FormArray;
  }

  get displayPropertyManagers(){
    if(this.userInfo?.["role_identifier"] == APP_CONSTANTS.USER_ROLES.PARTER_ADMIN || this.userInfo?.["role_identifier"] == APP_CONSTANTS.USER_ROLES.SUPER_ADMIN){
      return true;
    }
    return false;
  }
  
  // Staff roles can see/edit the property Status; owners and tenants cannot.
  get displayStatus(){
    const staffRoles = [
      APP_CONSTANTS.USER_ROLES.PARTER_ADMIN,
      APP_CONSTANTS.USER_ROLES.SUPER_ADMIN,
      APP_CONSTANTS.USER_ROLES.PROPERTY_MANAGER,
      APP_CONSTANTS.USER_ROLES.MAINTENANCE_MANAGER,
      APP_CONSTANTS.USER_ROLES.TELE_CALLER,
    ];
    return staffRoles.includes(this.userInfo?.["role_identifier"] ?? "");
  }

  get platformsArray() {
      return this.platformForm?.get('platforms') as FormArray;
  }
  

  ngOnDestroy(){
    this.routeSubscription?.unsubscribe();
    this.getCountriesSubscription?.unsubscribe();
    this.getStatesSubscription?.unsubscribe();
    this.getCitiesSubscription?.unsubscribe();
    this.updatePropertySubscription?.unsubscribe();
    this.getPropertyDetailsSubscription?.unsubscribe();
    this.updatePropertyDetailsSubscription?.unsubscribe();
    this.updatePropertyAmintiesSubscription?.unsubscribe();
    this.getAllPropertyManagersSubscription?.unsubscribe();
    this.getAllOwnersSubscription?.unsubscribe();
    this.uploadImagesSubscription?.unsubscribe();
    this.getImageSubscription?.unsubscribe();
    this.deleteImageSubscription?.unsubscribe();
    this.getAllPropertyImagesSubscription?.unsubscribe();
    this.savedAllowedListSubscription?.unsubscribe();
    this.getAllRoomItemsSubscription?.unsubscribe();
    this.saveRoomItemsSubscription?.unsubscribe();
    this.getPropertyRoomItemsSubscription?.unsubscribe();
    this.getAllPropertyRoomsSubscription?.unsubscribe();
    this.updatePropertyRoomItemDetailsSubscription?.unsubscribe();
    this.deletePropertyRoomSubscription?.unsubscribe();
    this.updatePlatformSubscription?.unsubscribe();
    this.queryParamsSubsscription?.unsubscribe();
  }

  get allFormControls() {
    return this.roomsForm?.get('selectedItems') as FormArray;
  }

  get checkAddImages() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.ADD_PROPERTY_IMAGES);
  }

  get checkDeleteImages() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.DELETE_PROPERTY_IMAGES);
  }

  get checkUpdateImageListing() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.UPDATE_PROPERTY_IMAGES_LISTING);
  }

}
